import {
  AccountFlagEnum,
  useUsageDashboardFeaturesListQuery,
} from '~/generated/graphql';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

export const useCreditUsage = () => {
  const { data, loading, error } = useUsageDashboardFeaturesListQuery();

  const hasUsageFlag = useFeatureFlag(AccountFlagEnum.XShowUsageOnPlatform)
    .enabled;

  const productFeature = data?.productFeatures.find(
    (item) =>
      item.id === 'free_tier' ||
      item.id === 'standard_bundle' ||
      item.id === 'paid_tier' ||
      item.id === 'business_tier',
  );

  const credits = productFeature?.usageLimit as number;
  const creditsUsed =
    productFeature?.currentPeriodTotalUsage.total?.credits || 0;
  const hasCredits = !!credits;
  const hasUsage = (hasUsageFlag || hasCredits) && !error;

  return {
    credits,
    creditsUsed,
    hasCredits,
    hasUsage,
    loading,
    planId: productFeature?.id,
  };
};
